var a;!function(a){a.custom="custom",a.pad="pad",a.padLine="padLine"}(a||(a={}));export{a as PadMode};
